import { render, staticRenderFns } from "./Mountains.vue?vue&type=template&id=c90b7f5c&"
import script from "./Mountains.vue?vue&type=script&lang=js&"
export * from "./Mountains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports